import { UNDEFINED_SPACE_KEY } from '../types/UNDEFINED_SPACE_KEY';
import { Space } from '../types/Space';
import { spaceFactory } from './spaceFactory';

/**
 * To explicitly define a space as not defined
 * @param _logError
 * @returns
 */
export const getUndefinedSpace = (_logError?: boolean): Space => {
  // TODO: log error here? should this ever be valid?
  return spaceFactory(UNDEFINED_SPACE_KEY, false).get();
};
